(function () {
    const urlPath = window.location.pathname;
    const isWellnessBox = urlPath === "/products/wellness-box" || urlPath.endsWith("/products/wellness-box");
    if (!isWellnessBox) return;

    function getAddToCartButtons() {
        const byClass = document.querySelectorAll(".add_to_cart_button");
        if (byClass.length) return byClass;
        const byName = document.querySelectorAll("button[name=\"add\"]");
        if (byName.length) return byName;
        const byForm = document.querySelectorAll("form[data-type=\"add-to-cart-form\"] button[type=\"submit\"]");
        if (byForm.length) return byForm;
        const byFormSel = document.querySelectorAll(".product-form__submit, [data-product-form] button[type=\"submit\"]");
        if (byFormSel.length) return byFormSel;
        var variantSel = document.querySelector("select.product-form__input") || document.querySelector("select[name=\"id\"]");
        if (variantSel && variantSel.closest("form")) {
            var btn = variantSel.closest("form").querySelector("button[type=\"submit\"], input[type=\"submit\"]");
            if (btn) return [btn];
        }
        var allSelects = document.querySelectorAll("select");
        for (var i = 0; i < allSelects.length; i++) {
            if (selectHasWellnessVariants(allSelects[i])) {
                var form = allSelects[i].closest("form");
                if (form) {
                    var b = form.querySelector("button[type=\"submit\"], input[type=\"submit\"]");
                    if (b) return [b];
                }
                break;
            }
        }
        return [];
    }

    function getAddToCartButton() {
        const list = getAddToCartButtons();
        return list.length ? list[0] : null;
    }

    function selectHasWellnessVariants(sel) {
        if (!sel || !sel.options) return false;
        for (var j = 0; j < sel.options.length; j++) {
            var opt = sel.options[j];
            var v = (opt.value || "").trim();
            var t = (opt.textContent || "").trim();
            for (var k = 0; k < WELLNESS_OPTION_VALUES.length; k++) {
                if (v === WELLNESS_OPTION_VALUES[k] || t === WELLNESS_OPTION_VALUES[k]) return true;
            }
        }
        return false;
    }

    function getBundleVariantSelect() {
        var sel = document.querySelector("select.product-form__input");
        if (sel) return sel;
        sel = document.querySelector("select[name=\"id\"]");
        if (sel) return sel;
        var allSelects = document.querySelectorAll("select");
        for (var i = 0; i < allSelects.length; i++) {
            if (selectHasWellnessVariants(allSelects[i])) return allSelects[i];
        }
        return null;
    }

    const VARIANT_STRENGTH = "44764648243254";
    const VARIANT_CREATINE = "44764648276022";
    const STRENGTH_OPTION = "Hydration Box";
    const CREATINE_OPTION = "Strength + Hydration Box";
    const WELLNESS_OPTION_VALUES = [VARIANT_STRENGTH, VARIANT_CREATINE, STRENGTH_OPTION, CREATINE_OPTION, "Creatine + Hydration Box"];

    const flavorTranslations = {
        "Mixed Berry": "Frutos Rojos",
        "Lemon Lime": "Lima Limón",
        "Watermelon Hibiscus": "Sandía Hibisco",
        "Coconut Lime": "Coco Limón",
        "Passion Fruit": "Maracuyá",
        "Tangerine": "Mandarina"
    };
    const flavorListEN = Object.keys(flavorTranslations);

    function getLang() {
        return (window.Shopify && Shopify.locale) || document.documentElement.lang || "en";
    }

    function getVariantFromUrl() {
        try {
            const params = new URLSearchParams(window.location.search);
            let variant = params.get("variant") || "";
            if (!variant && window.location.href) {
                const match = window.location.href.match(/[?&]variant=([^&?#]+)/);
                if (match) variant = decodeURIComponent(match[1].replace(/\+/g, " ")).trim();
            }
            return variant;
        } catch (e) {
            return "";
        }
    }

    function getFlavorSelectCountFromUrl() {
        const variant = String(getVariantFromUrl()).trim();
        if (variant === VARIANT_STRENGTH) return 4;
        if (variant === VARIANT_CREATINE) return 3;
        return 0;
    }

    function getFlavorSelectCountFromSelect(selectEl) {
        if (!selectEl || !selectEl.options || !selectEl.options[selectEl.selectedIndex]) return 0;
        const option = selectEl.options[selectEl.selectedIndex];
        const text = (option.textContent || "").trim();
        const val = (option.value || "").trim();
        if (text === STRENGTH_OPTION || val === STRENGTH_OPTION || val === VARIANT_STRENGTH) return 4;
        if (text === CREATINE_OPTION || val === CREATINE_OPTION || text === "Creatine + Hydration Box" || val === "Creatine + Hydration Box" || val === VARIANT_CREATINE) return 3;
        return 0;
    }

    function getFlavorSelectCount(useUrl, selectEl) {
        if (useUrl) {
            const fromUrl = getFlavorSelectCountFromUrl();
            if (fromUrl > 0) return fromUrl;
            // Default to 4 (Hydration Box) when no variant in URL
            return 4;
        }
        const count = getFlavorSelectCountFromSelect(selectEl);
        // If no select element, default to 4
        return count > 0 ? count : 4;
    }

    function syncSelectToUrlVariant(selectEl) {
        const variantId = getVariantFromUrl();
        if (!variantId || !selectEl || !selectEl.options) return;
        for (var i = 0; i < selectEl.options.length; i++) {
            var opt = selectEl.options[i];
            if ((opt.value || "").trim() === variantId) {
                selectEl.selectedIndex = i;
                return;
            }
        }
    }

    function isCreatineVariant(val) {
        if (!val) return false;
        val = String(val).trim();
        return val === VARIANT_CREATINE || val === CREATINE_OPTION || val === "Creatine + Hydration Box";
    }

    function setDescriptionVisibility(selectEl, variantIdFromUrl) {
        var hydrationDesc = document.querySelector(".hydrate-description");
        var creatineDesc = document.querySelector(".creatine-description");
        function show(el, visible) {
            if (!el) return;
            el.style.setProperty("display", visible ? "block" : "none", "important");
        }
        show(hydrationDesc, false);
        show(creatineDesc, false);
        var val = variantIdFromUrl || (selectEl && selectEl.value && selectEl.options[selectEl.selectedIndex] ? (selectEl.options[selectEl.selectedIndex].value || selectEl.options[selectEl.selectedIndex].textContent || "") : null) || null;
        if (val) val = String(val).trim();
        if (isCreatineVariant(val)) {
            show(hydrationDesc, true);
            show(creatineDesc, true);
        } else {
            show(hydrationDesc, true);
        }
    }

    function createFlavorSelect(index, wrapperRef, isSpanish) {
        const label = document.createElement("label");
        label.textContent = isSpanish ? "Sabor " + index : "Flavor " + index;
        label.style.cssText = "font-size: 14px !important; font-weight: 600 !important; visibility: visible !important; opacity: 1 !important; display: block !important;";

        const select = document.createElement("select");
        select.id = "flavorSelect" + index;
        select.name = "properties[Flavor " + index + "]";
        select.style.cssText = "padding: 6px !important; margin-top: 4px !important; visibility: visible !important; opacity: 1 !important; display: block !important; width: 100% !important;";

        const placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = isSpanish ? "Selecciona un sabor" : "Select a flavor";
        placeholder.disabled = true;
        placeholder.selected = true;
        select.appendChild(placeholder);

        flavorListEN.forEach(function (flavorEN) {
            const opt = document.createElement("option");
            const spanishLabel = flavorTranslations[flavorEN];
            opt.value = isSpanish ? spanishLabel : flavorEN;
            opt.textContent = isSpanish ? spanishLabel : flavorEN;
            select.appendChild(opt);
        });

        select.addEventListener("change", function () {
            validateSelects(wrapperRef);
        });

        const fieldBox = document.createElement("div");
        fieldBox.style.cssText = "display: flex !important; flex-direction: column !important; visibility: visible !important; opacity: 1 !important; margin-bottom: 8px !important;";
        fieldBox.appendChild(label);
        fieldBox.appendChild(select);
        return fieldBox;
    }

    function setButtonEnabled(enabled) {
        getAddToCartButtons().forEach(function (btn) {
            btn.disabled = !enabled;
        });
    }

    function areFlavorsValid() {
        const wrapper = document.getElementById("bundle-flavor-selects-wrapper");
        if (!wrapper) return false;
        const selects = wrapper.querySelectorAll("select");
        if (selects.length === 0) return false;
        return Array.from(selects).every(function (sel) { return sel.value && sel.value.trim(); });
    }

    function validateSelects(wrapper) {
        if (!wrapper) return;
        const selects = wrapper.querySelectorAll("select");
        const allSelected = selects.length > 0 && Array.from(selects).every(function (sel) { return sel.value; });
        setButtonEnabled(allSelected);
    }

    function injectFlavorSelects(useUrlOnLoad, selectEl) {
        const existing = document.getElementById("bundle-flavor-selects-wrapper");
        if (existing) existing.remove();

        if (useUrlOnLoad && selectEl) syncSelectToUrlVariant(selectEl);
        const count = getFlavorSelectCount(useUrlOnLoad, selectEl);

        if (count === 0) {
            setButtonEnabled(false);
            return;
        }

        const isSpanish = getLang().startsWith("es");
        const wrapper = document.createElement("div");
        wrapper.id = "bundle-flavor-selects-wrapper";
        wrapper.style.cssText = "display: flex !important; flex-direction: column !important; gap: 10px !important; margin: 15px 0 !important; visibility: visible !important; opacity: 1 !important; position: relative !important; width: 100% !important;";

        for (var i = 1; i <= count; i++) {
            wrapper.appendChild(createFlavorSelect(i, wrapper, isSpanish));
        }

        const addToCartBtn = getAddToCartButton();
        if (!addToCartBtn || !addToCartBtn.parentNode) return;

        addToCartBtn.parentNode.insertBefore(wrapper, addToCartBtn);

        // If wrapper has zero dimensions, the form might not be laid out yet - remove and retry
        var rect = wrapper.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) {
            wrapper.remove();
            return;
        }

        setButtonEnabled(false);
    }

    function runInit() {
        const addToCartBtn = getAddToCartButton();
        if (!addToCartBtn) return false;

        const bundleSelect = getBundleVariantSelect();

        if (window._bundleFlavorBound) {
            if (!document.getElementById("bundle-flavor-selects-wrapper")) {
                injectFlavorSelects(true, bundleSelect || null);
            }
            return true;
        }
        window._bundleFlavorBound = true;

        document.body.addEventListener("change", function (e) {
            if (!e.target || e.target.tagName !== "SELECT" || !selectHasWellnessVariants(e.target)) return;
            var sel = e.target;
            injectFlavorSelects(false, sel);
            setDescriptionVisibility(sel);
        });

        addToCartBtn.addEventListener("click", function (e) {
            if (!areFlavorsValid()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });

        const form = addToCartBtn.closest("form");
        if (form) {
            form.addEventListener("submit", function (e) {
                if (!areFlavorsValid()) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });
        }

        injectFlavorSelects(true, bundleSelect || null);
        setDescriptionVisibility(bundleSelect || null, getVariantFromUrl() || undefined);

        function retryInitialInjection() {
            if (document.getElementById("bundle-flavor-selects-wrapper")) return;
            const sel = getBundleVariantSelect();
            if (sel) {
                injectFlavorSelects(true, sel);
                setDescriptionVisibility(sel, getVariantFromUrl() || undefined);
            } else {
                injectFlavorSelects(true, null);
                setDescriptionVisibility(null, getVariantFromUrl() || undefined);
            }
        }
        [100, 300, 600, 1000, 1500, 2000, 3000].forEach(function (delay) {
            setTimeout(retryInitialInjection, delay);
        });

        return true;
    }

    function tryInit() {
        if (runInit()) return;
        setTimeout(tryInit, 200);
        setTimeout(tryInit, 500);
        setTimeout(tryInit, 1000);
        setTimeout(tryInit, 1500);
        setTimeout(tryInit, 2500);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", tryInit);
    } else {
        tryInit();
    }
    window.addEventListener("load", tryInit);

    function pollUrlVariantInjection() {
        if (document.getElementById("bundle-flavor-selects-wrapper")) return;
        if (!getAddToCartButton()) return;
        const sel = getBundleVariantSelect();
        if (sel) {
            syncSelectToUrlVariant(sel);
            injectFlavorSelects(true, sel);
            setDescriptionVisibility(sel, getVariantFromUrl() || undefined);
        } else {
            injectFlavorSelects(true, null);
            setDescriptionVisibility(null, getVariantFromUrl() || undefined);
        }
    }
    [0, 100, 200, 400, 600, 1000, 1500, 2500, 4000, 6000, 9000].forEach(function (delay) {
        setTimeout(pollUrlVariantInjection, delay);
    });

    var initDebounce = null;
    function scheduleInitFromMutation() {
        if (initDebounce) clearTimeout(initDebounce);
        initDebounce = setTimeout(function () {
            initDebounce = null;
            tryInit();
            if (!document.getElementById("bundle-flavor-selects-wrapper") && getAddToCartButton()) {
                var sel = getBundleVariantSelect();
                if (sel) {
                    syncSelectToUrlVariant(sel);
                    injectFlavorSelects(true, sel);
                    setDescriptionVisibility(sel, getVariantFromUrl() || undefined);
                } else {
                    injectFlavorSelects(true, null);
                    setDescriptionVisibility(null, getVariantFromUrl() || undefined);
                }
            }
        }, 150);
    }

    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var list = mutations[i].addedNodes;
            if (!list || !list.length) continue;
            for (var j = 0; j < list.length; j++) {
                var node = list[j];
                if (node.nodeType !== 1) continue;
                if (node.querySelector && (node.querySelector(".add_to_cart_button") || node.querySelector("button[name=\"add\"]") || node.querySelector("select.product-form__input"))) {
                    scheduleInitFromMutation();
                    return;
                }
                if (node.classList && (node.classList.contains("add_to_cart_button") || node.classList.contains("product-form__input") || (node.tagName === "SELECT" && node.classList.contains("product-form__input")))) {
                    scheduleInitFromMutation();
                    return;
                }
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    function applyDefaultDescription() {
        setDescriptionVisibility(null, getVariantFromUrl() || undefined);
    }
    applyDefaultDescription();
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", applyDefaultDescription);
    }
    window.addEventListener("load", applyDefaultDescription);
    [100, 300, 500, 1000, 2000, 4000].forEach(function (delay) {
        setTimeout(applyDefaultDescription, delay);
    });
})();
 